import React, { useContext,  useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

import { getUsuarioStorage } from '../helpers/getUsuarioStorage';
import { SocketContext } from '../context/SocketContext'

import LoadingOverlay from './LoadingOverlay'


export const UsuarioPassword = ( props ) => {
    
    const { socket } = useContext( SocketContext );

    const [ isLoading, setIsLoading ] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [contenidoError, setContenidoError] = useState(false);

    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    const uidUsuario = usuario.uidUsuario;

    const handleSubmit = (ev, props) => {

        console.log(props)
        ev.preventDefault();
      

        setShowAlert(false)
        setContenidoError('');
        
        const anteriorPassword  = ev.target.anteriorPassword.value;
        const nuevoPassword     = ev.target.nuevoPassword.value;
        const repitePassword    = ev.target.repitePassword.value;

        if ( anteriorPassword === "" || nuevoPassword === "" || repitePassword === "" ){
            setShowAlert(true)
            return setContenidoError('Ninguno de los campos puede ir vacío');
            
        }else
        if ( anteriorPassword === nuevoPassword ){
            setShowAlert(true)
            return setContenidoError('El password anterior no puede ser igual al nuevo');
        }else        
        if (  nuevoPassword !== repitePassword  ){
            setShowAlert(true)
            return setContenidoError('El password nuevo y su repetición no coinciden ');
        }

        const datos={
            entidad,
            uidUsuario,
            anteriorPassword,
            nuevoPassword
        }

        setIsLoading(true);
        socket.emit( 'cambia-Password', datos, ( res ) => {
            console.log( res )
            setIsLoading(false);
            if( res[0] === "" ){
                setShowAlert(true)
                setContenidoError( res[1] );
            }else
            if( res[0] === 1 ){
                props.onHide(false)
                console.log (props.onHide);
                setShowAlert(false);
            }else{
                console.log( res );
            }


        })



    }
  
    return (
      <>
        {isLoading && <LoadingOverlay />}

        <Modal 
            {...props}
            className={`content ${isLoading ? 'opacity' : ''} m-5`}
        >
          <Modal.Header closeButton>
            <Modal.Title>Cambio Passwoord</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            { showAlert && (

                <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                <Alert.Heading>Atencion!</Alert.Heading>
                <p>
                    { contenidoError }
                </p>
                </Alert>

            )}

          
            <Form onSubmit={ (ev) => handleSubmit(ev, props)}>
                <Form.Group className="mb-3" controlId="anteriorPassword">
                    <Form.Label>Password Anterior</Form.Label>
                        <Form.Control
                        type="password"
                        placeholder="Password Anterior"
                        autoFocus
                        autoComplete='nope'
                    />
                </Form.Group>

                <Form.Group className="mb-3" controlId="nuevoPassword">
                    <Form.Label>Nuevo Password</Form.Label>
                        <Form.Control
                        type="password"
                        placeholder=""
                        autoComplete='nope'
                        
                    />
                </Form.Group>

                <Form.Group className="mb-3" controlId="repitePassword">
                    <Form.Label>Repita Password</Form.Label>
                        <Form.Control
                        type="password"
                        placeholder=""
                        autoComplete='nope'
                    />
                </Form.Group>
              
                <Form.Group>
                    <Button type='submit' className="m-1" variant="success" style={{float: 'right'}}>
                        Guardar
                    </Button>

                    <Button className="m-1" variant="secondary" style={{float: 'right'}} onClick={props.onHide}>
                        Cancelar
                    </Button>
                </Form.Group>
            </Form>
          </Modal.Body>
          {/* <Modal.Footer>
            
          </Modal.Footer> */}
        </Modal>
      </>
  )
}
